import { AnalysisStatus, FileUploadStatus } from "@explorance/mly-types";
import { AnalysisContextState } from "context/AnalysisContext/state";

export const isSettingsPageUnavailable = (analysisState: AnalysisContextState) =>
  analysisState.analysisDetails.status === AnalysisStatus.NotAnalyzed &&
  analysisState.analysisDetails.uploadStatus !== FileUploadStatus.Completed;
